import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { isEmpty } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import { applicationInfoType } from "types/app";
import BasicMenu from "./Components/BasicMenu";
import CreateAppDialog from "./Components/CreateAppDialog";
import {
	ApplicationContainer,
	ApplicationTitle,
	ApplicationHeader,
	NameText,
	ContentContainer,
	ContentBody,
	AppNameContainer,
	ImageContainer,
	DescriptionContainer,
	ApiText,
	ApiContainer,
} from "./style";
import ic_android from "@/assets/ic_android.svg";
import { createTimeFormat } from "@/utils/timeFormat";
import { useSelector } from "react-redux";
import { getUserInfo } from "@/redux/user/selector";
import { useTranslation } from "react-i18next";

interface IApplicationSectionProps {
	ApplicationInfo: applicationInfoType[];
	setApplicationInfo: (value: applicationInfoType[]) => void;
	maxAppCount: number | undefined;
}
const ApplicationSection: React.FC<IApplicationSectionProps> = ({
	setApplicationInfo,
	ApplicationInfo,
	maxAppCount,
}) => {
	const { t, i18n } = useTranslation();
	const userInfo = useSelector(getUserInfo);
	const history = useHistory();
	const [openModal, setModalOpen] = React.useState(false);
	const handleModalClose = () => {
		setModalOpen(false);
	};
	return (
		<ApplicationContainer>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<ApplicationTitle>
					{t("application_title")}
					<div style={{ fontSize: "0.75rem", color: "#696969" }}>
						{i18n.language === "ko" && (
							<>
								최대 {maxAppCount}개의 애플리케이션을 만들 수 있습니다.
								현재 {ApplicationInfo.length}개의 애플리케이션이 있습니다.
							</>
						)}
						{i18n.language === "en" && (
							<>
								You can create up to {maxAppCount} applications.
								Currently, you have {ApplicationInfo.length} applications.
							</>
						)}
					</div>
				</ApplicationTitle>
				{/* {ApplicationInfo.length === 0 && (
					<Button
						variant="outlined"
						endIcon={<AddIcon />}
						onClick={() => {
							setModalOpen(true);
						}}
						sx={{
							color: "white",
							borderColor: "#a9a9a9",
							height: "2.5rem",
							alignSelf: "center",
							backgroundColor: "#0071E3",
							"&:hover": { backgroundColor: "rgb(2 95 189)" },
						}}
					>
						어플 추가하기
					</Button>
				)} */}
				<Button
					variant="outlined"
					endIcon={<AddIcon />}
					onClick={() => {
						setModalOpen(true);
					}}
					sx={{
						color: "white",
						borderColor: "#a9a9a9",
						height: "2.5rem",
						alignSelf: "center",
						backgroundColor: "#0071E3",
						"&:hover": { backgroundColor: "rgb(2 95 189)" },
					}}
				>
					{t("application_add_button")}
				</Button>
				{userInfo != null && (
					<CreateAppDialog
						openModal={openModal}
						setModalOpen={setModalOpen}
						handleModalClose={handleModalClose}
						applicationInfo={ApplicationInfo}
						setApplicationInfo={setApplicationInfo}
						defaultEmail={userInfo.email}
					/>
				)}
			</div>
			<div>
				<ApplicationHeader>
					<NameText>{t("application_name")}</NameText>
					<ApiText>{t("application_api")}</ApiText>
					<span>{t("application_created_at")}</span>
				</ApplicationHeader>

				<div style={{ border: "1px solid #E0E0E0", marginBottom: "1rem" }} />
				{!isEmpty(ApplicationInfo) &&
					ApplicationInfo.map((ApplicationItem, index) => {
						return (
							<ContentContainer key={index}>
								<ContentBody
									onClick={() => {
										history.push(
											`/application/${ApplicationItem.id}/dashboard`,
										);
									}}
								>
									<AppNameContainer>
										<ImageContainer>
											<img
												src={ic_android}
												alt="사진없음"
												style={{ width: "100%" }}
											/>
										</ImageContainer>
										<DescriptionContainer>
											<h3>{ApplicationItem.name}</h3>
										</DescriptionContainer>
									</AppNameContainer>
									<ApiContainer>
										{ApplicationItem.isFoodLens
											? "FoodLens 1.0"
											: "CaloAI"}
									</ApiContainer>
									<div>
										{i18n.language === "ko" && (
											<>
												{ApplicationItem.createdAt !== ""
													? createTimeFormat(
															ApplicationItem.createdAt,
													  )
													: "-"}
											</>
										)}
										{i18n.language === "en" && (
											<>
												{ApplicationItem.createdAt !== ""
													? new Date(
															ApplicationItem.createdAt,
													  ).toLocaleString("en-US", {
															month: "long",
															year: "numeric",
															day: "numeric",
													  })
													: "-"}
											</>
										)}
									</div>
								</ContentBody>
								{userInfo?.isOwner && (
									<BasicMenu
										ApplicationInfo={ApplicationInfo}
										ApplicationItem={ApplicationItem}
										setApplicationInfo={setApplicationInfo}
									/>
								)}
							</ContentContainer>
						);
					})}
			</div>
		</ApplicationContainer>
	);
};

export default ApplicationSection;
